import { render, staticRenderFns } from "./mask.vue?vue&type=template&id=18def815&scoped=true&"
import script from "./mask.vue?vue&type=script&lang=js&"
export * from "./mask.vue?vue&type=script&lang=js&"
import style0 from "./mask.vue?vue&type=style&index=0&id=18def815&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18def815",
  null
  
)

export default component.exports